import { useEffect } from 'react';

export const usePageTitle = (title: string) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};

export const getPageTitle = (pageTitle: string) => {
  return `${pageTitle} | El Impostor Game`;
};